import { render } from "./TitleCom.vue?vue&type=template&id=14c81d5c&scoped=true"
import script from "./TitleCom.vue?vue&type=script&lang=js"
export * from "./TitleCom.vue?vue&type=script&lang=js"

import "./TitleCom.vue?vue&type=style&index=0&id=14c81d5c&scoped=true&lang=less"

import exportComponent from "D:\\Jhy\\点甜官网\\2026最新版官网\\officialwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14c81d5c"]])

export default __exports__